<div class="linked-existing-items" *ngrxLet="store.vm$ as vm">
  @if (vm.startSpinner) {
    <mat-spinner class="linked-existing-items__spinner"></mat-spinner>
  }
  <mat-toolbar class="linked-existing-items__header">
    <div class="linked-existing-items__header-type">
      <h2 class="linked-existing-items__header-title" data-cy="">Link to Existing Items</h2>
      <p class="linked-existing-items__header-description">
        <strong>Link to {{ vm.fromLinkedItemName }}: </strong> {{ vm.fromLinkedItemTitle }}
      </p>
    </div>

    <div class="linked-existing-items__header-controls">
      <button
        name="close"
        data-cy="linked_existing-items-dialog__header-controls__close"
        mat-button
        [disableRipple]="true"
        class="linked-existing-items__header-controls__close"
        (click)="dialogRef.close()"
        title="Close">
        <terra-icon icon="x" aria-activedescendant="" />
      </button>
    </div>
  </mat-toolbar>
  <mat-dialog-content class="linked-existing-items__content">
    <div class="linked-existing-items__list-item-container__header">
      <div class="linked-existing-items__list-item-container__header__title">
        <terra-search-input
          [ngModel]="vm.searchText"
          placeholder="Search for {{ vm.entity.name }} on your team"
          (ngModelChange)="store.handleSearchTextInput($event)"></terra-search-input>
        <div>
          <strong>{{ vm.entity.name }} in </strong> {{ vm.teamName }}
        </div>
      </div>
    </div>
    <mat-tab-group
      #tabGroup
      preserveContent="true"
      animationDuration="0"
      fitInkBarToContent
      [disableRipple]="true"
      (selectedIndexChange)="this.store.onSelectedIndexChanged($event)"
      [selectedIndex]="vm.selectedTabIndex">
      @for (entity of vm.entities; track $index) {
        <ng-container [ngTemplateOutlet]="tabContentTemplate" [ngTemplateOutletContext]="{ entity: entity | async }">
        </ng-container>
      }

      <ng-template #tabContentTemplate let-entity="entity">
        <mat-tab [label]="entity.tabName">
          <ng-template matTabContent>
            <div class="linked-existing-items__list-item-container">
              @if (entity.items.length > 0) {
                <div class="linked-existing-items__list">
                  @for (item of entity.items; track item._id; let i = $index) {
                    <div class="linked-existing-items__list__item-content">
                      @if (entity.type === 'goal' && item.isCompanyGoalStartingIndex) {
                        <h3 class="linked-existing-items__goals-heading">Leadership {{ entity.name }}</h3>
                      }
                      @if (entity.type === 'goal' && item.isTeamGoalStartingIndex) {
                        <h3 class="linked-existing-items__goals-heading">Team {{ entity.name }}</h3>
                      }
                      @if (i + 1 === entity.items.length) {
                        <div
                          class="linked-existing-items__list__item-content__item"
                          [ninetyNotifyIntersect]="true"
                          [threshold]="0.5"
                          (isIntersecting)="fetchMore($event)">
                          <div class="linked-existing-items__list__item-content__item__left-column-item">
                            <terra-icon [icon]="entity.iconKey" [variant]="entity.iconVariant" />
                            <div class="linked-existing-items__list__item-content__item__left-column-item__title">
                              {{ entity.type === 'goal' ? item.description : item.title }}
                            </div>
                          </div>
                          <terra-checkbox
                            [ngModel]="item.selected"
                            (change)="store.toggleItemSelection({ checked: $event, type: entity.type, index: i })" />
                        </div>
                      }
                      @if (i + 1 !== entity.items.length) {
                        <div class="linked-existing-items__list__item-content__item">
                          <div class="linked-existing-items__list__item-content__item__left-column-item">
                            <terra-icon [icon]="entity.iconKey" [variant]="entity.iconVariant" />
                            <div class="linked-existing-items__list__item-content__item__left-column-item__title">
                              {{ entity.type === 'goal' ? item.description : item.title }}
                            </div>
                          </div>
                          <terra-checkbox
                            [ngModel]="item.selected"
                            (change)="store.toggleItemSelection({ checked: $event, type: entity.type, index: i })" />
                        </div>
                      }
                    </div>
                  }
                </div>
              } @else {
                <div class="linked-existing-items__list__no-items">
                  @if (!vm.error) {
                    <ninety-alert alertClass="secondary">
                      There are no {{ entity.name }} found with your team {{ vm.teamName }}
                    </ninety-alert>
                  } @else {
                    <ninety-alert alertClass="danger">
                      {{ vm.error }}
                    </ninety-alert>
                  }
                </div>
              }
            </div>
          </ng-template>
        </mat-tab>
      </ng-template>
    </mat-tab-group>
    <terra-divider height="tiny" />
  </mat-dialog-content>
  <mat-dialog-actions class="linked-existing-items__actions">
    <span class="linked-existing-items__actions__selected-count">
      {{ vm.totalCount }} {{ vm.totalCount > 1 ? 'items' : 'item' }}
    </span>
    <ninety-button
      filled
      primary
      data-cy="linked-existing-items__actions__link-button"
      (click)="createLinkedItems()"
      ninetyStopPropagation
      [disabled]="!vm.totalCount"
      class="linked-existing-items__actions__create-link-button">
      Link items to {{ vm.fromLinkedItemName }}
    </ninety-button>
  </mat-dialog-actions>
</div>
